import PropTypes from 'prop-types';

const GlobeIcon = props => {
  const { size, fill } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d={`M5.92583 14.9802C2.55493 14.3291 0 11.256 0 7.55608C0 3.3831 3.24861
        0 7.25642 0C11.0306 0 14.1293 3.00105 14.4772 6.83746C14.4394 6.88522
        14.3986 6.93144 14.3687 6.98676C14.0812 7.50753 13.6146 7.857 13.0782
        7.98662C13.0891 7.84409 13.1073 7.70236 13.1073 7.55608C13.1073 6.57742
        12.8794 5.65414 12.4835 4.83399L12.1042 5.03257C11.9943 5.08869 11.9011
        5.17431 11.8334 5.28045L11.2606 6.1757C11.1034 6.42131 11.1034 6.74116
        11.2606 6.98676L11.7869 7.8085C11.8568 7.9184 11.9587 7.99344 12.0708
        8.0503H11.321C10.5502 8.0503 9.83465 8.29209 9.2283 8.6946C9.08057
        8.59835 8.91821 8.53087 8.74133 8.53087H6.78839C6.51325 8.3876 6.15949
        7.55608 5.85159 7.55608C5.54439 7.55608 5.24086 7.48103 4.96501
        7.33777L4.64111 7.16869C4.52242 7.10655 4.44747 6.98073 4.44747
        6.84349C4.44747 6.68658 4.54426 6.54712 4.68697 6.49783L5.59899
        6.18173C5.7555 6.12641 5.92873 6.1628 6.05396 6.27576L6.32474 6.52137C6.36765
        6.56003 6.42224 6.58123 6.47831 6.58123H6.64356C6.81749 6.58123 6.93033
        6.39021 6.85243 6.22801L6.39604 5.27744C6.35094 5.18266 6.36983 5.06822
        6.44266 4.99391L6.73309 4.69982C6.77677 4.65581 6.83573 4.6308 6.8961
        4.6308H7.15891C7.22148 4.6308 7.2812 4.60504 7.32487 4.55956L7.55924
        4.31623C7.65025 4.22072 7.65025 4.06684 7.55924 3.97133L7.42167 3.82806C7.33066
        3.73331 7.33066 3.57867 7.42167 3.48391L7.72449 3.16858L7.8613 3.02606C8.04402
        2.8358 8.04402 2.52652 7.8613 2.33626L7.03297 1.47438C6.79129 1.48347 6.55326
        1.50924 6.32037 1.5479V1.89205C6.32037 2.25515 5.95351 2.49013 5.64195 2.32867L4.94027
        1.96254C3.59874 2.56745 2.51926 3.681 1.92092 5.06668C2.21063 5.51542 2.65829 6.20601
        2.93271 6.62518C3.08338 6.85714 3.26099 7.06863 3.46116 7.25738L3.48445 7.27938C3.76324
        7.54164 4.07477 7.7653 4.41035 7.94188C4.81941 8.15644 5.41774 8.49448 5.83849
        8.73707C6.13694 8.90837 6.32037 9.2351 6.32037 9.58986V10.5647C6.32037 10.824
        6.41864 11.0718 6.59404 11.2545C7.03297 11.7116 7.30593 12.4317 7.25642
        12.8161V12.9434C6.60131 13.6052 6.16604 14.301 5.94838 14.8574C5.93238 14.8976
        5.93746 14.9393 5.92583 14.9802ZM15.5159 7.41429C15.4249 7.20206 15.1651 7.1945
        15.0559 7.39382C14.5529 8.30573 13.651 8.87426 12.6211 8.87426H11.321C9.59881
        8.87426 8.20125 10.3289 8.20125 12.1225C8.20125 12.2415 8.21511 12.3544 8.22603
        12.4696C9.26252 11.6964 10.7591 11.04 12.8809 11.04C13.0236 11.04 13.1408 11.162
        13.1408 11.3106C13.1408 11.4592 13.0236 11.582 12.8809 11.582C8.79598 11.582 7.0643
        14.1888 6.68068 15.1682C6.57368 15.4441 6.70034 15.7587 6.96527 15.8724C7.23168
        15.9876 7.5338 15.8535 7.6444 15.5798C7.66919 15.5184 7.98364 14.7695 8.81268
        14.0471C9.33895 14.7892 10.3399 15.4987 11.6544 15.3524C14.205 15.1599 16 12.7781 16
        9.86048C16 9.0115 15.8253 8.13142 15.5159 7.41429Z`}
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

GlobeIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string
};

GlobeIcon.defaultProps = {
  size: '20',
  fill: '#658D1B'
};

export default GlobeIcon;
